import React from 'react';
import { COLORS, Image, ImageEntity, SIZES, Typography } from '@fupa/fupa-uikit';
import { LinkOnComponent } from 'app/components/links/link';
import { ToTeamAlt } from 'app/styles/stream';
import { Emblem } from 'app/components/icons';
import styled from 'styled-components';
import { FlexContainer } from 'app/styles/content';
import formatTeamNameWithLevel from 'app/helpers/formatTeamNameWithLevel';
const LinkContainer = styled(LinkOnComponent).withConfig({
  componentId: "sc-115qv42-0"
})(["flex:1;overflow:hidden;"]);
const Team = styled(FlexContainer).withConfig({
  componentId: "sc-115qv42-1"
})(["flex-direction:column;align-items:center;flex:1;width:100%;white-space:nowrap;overflow:hidden;"]);
const NameContainer = styled('div').withConfig({
  componentId: "sc-115qv42-2"
})(["width:inherit;"]);
const TeamName = styled(Typography).withConfig({
  componentId: "sc-115qv42-3"
})(["&&&{color:", ";}display:block;line-height:", ";width:inherit;overflow:hidden;text-overflow:ellipsis;text-align:center;"], COLORS.black, SIZES['24']);
const CompetitionName = styled(Typography).withConfig({
  componentId: "sc-115qv42-4"
})(["display:block;width:inherit;overflow:hidden;text-overflow:ellipsis;text-align:center;"]);
export default function MatchHeaderTeam(_ref) {
  var _team$name, _team$competition;
  let {
    team,
    fallbackName
  } = _ref;
  const emblem = team !== null && team !== void 0 && team.image ? /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    src: team.image,
    width: 64,
    height: 64,
    fit: true
  }) : /*#__PURE__*/React.createElement(ToTeamAlt, null, /*#__PURE__*/React.createElement(Emblem, {
    className: "",
    style: {
      color: COLORS.lightGrey,
      fontSize: 64
    }
  }));
  const name = team !== null && team !== void 0 && (_team$name = team.name) !== null && _team$name !== void 0 && _team$name.middle ? formatTeamNameWithLevel(team.name.middle, team.level) : fallbackName;
  const competitionName = team !== null && team !== void 0 && (_team$competition = team.competition) !== null && _team$competition !== void 0 && _team$competition.name ? /*#__PURE__*/React.createElement(CompetitionName, {
    variant: "caption1",
    component: "span"
  }, team.competition.name) : null;
  const content = /*#__PURE__*/React.createElement(Team, null, emblem, /*#__PURE__*/React.createElement(NameContainer, null, /*#__PURE__*/React.createElement(TeamName, {
    variant: "subheading2",
    component: "span"
  }, name, competitionName)));
  return team !== null && team !== void 0 && team.clubSlug && team.clubSlug !== 'dummy' ? /*#__PURE__*/React.createElement(LinkContainer, {
    to: "/team/".concat(team.slug),
    "data-sentry-element": "LinkContainer",
    "data-sentry-component": "MatchHeaderTeam",
    "data-sentry-source-file": "MatchHeaderTeam.tsx"
  }, content) : content;
}